/* @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import classNames from 'classnames';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/discussions';

type Props = {
  initials: string | JSX.Element;
  color?: string;
  photoUrl?: string;
  className?: string;
  name?: string;
};

export default function ProfileAvatar({ initials, className, photoUrl, name }: Props) {
  const styles = {
    borderRadius: '50px',
    width: '36px',
    height: '36px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    overflow: 'hidden',
    verticalAlign: 'middle',
    backgroundColor: 'var(--cds-color-blue-50)',

    '.rc-ProfileAvatar__profileImage': {
      width: '36px',
      height: '36px',
      verticalAlign: 'middle',
    },
  };

  return (
    <Typography2 component="span" className={classNames('classNames', className)} css={styles} aria-hidden="true">
      {photoUrl && (
        <img
          className="rc-ProfileAvatar__profileImage"
          src={photoUrl}
          alt={name ? _t('#{name} avatar', { name }) : _t('User avatar')}
        />
      )}
      {!photoUrl && initials}
    </Typography2>
  );
}
